import type { MappedSchemaSpec } from "@automerge/prosemirror";

// This is where we would specify any "custom" schemas
export const catcolabSchema = {
    nodes: {},
} satisfies MappedSchemaSpec;
